import type { JSX } from "react";
import type { DeviceProfile } from "../types";
import { formatNumber } from "./format";

export const EngagementPanel = ({
  profile,
}: {
  profile: DeviceProfile;
}): JSX.Element => (
  <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
    <div className="rounded-lg border border-(--border-color) p-3">
      <p className="text-xs uppercase text-(--text-secondary)">Total VASTs</p>
      <p className="mt-1 text-lg font-semibold">
        {formatNumber(profile.engagement.totalVasts)}
      </p>
    </div>
    <div className="rounded-lg border border-(--border-color) p-3">
      <p className="text-xs uppercase text-(--text-secondary)">Paid</p>
      <p className="mt-1 text-lg font-semibold">
        {formatNumber(profile.engagement.paidCount)}
      </p>
    </div>
    <div className="rounded-lg border border-(--border-color) p-3">
      <p className="text-xs uppercase text-(--text-secondary)">Free</p>
      <p className="mt-1 text-lg font-semibold">
        {formatNumber(profile.engagement.freeCount)}
      </p>
    </div>
    <div className="rounded-lg border border-(--border-color) p-3">
      <p className="text-xs uppercase text-(--text-secondary)">Livestream</p>
      <p className="mt-1 text-lg font-semibold">
        {formatNumber(profile.engagement.livestreamCount)}
      </p>
    </div>
    <div className="rounded-lg border border-(--border-color) p-3">
      <p className="text-xs uppercase text-(--text-secondary)">
        Avg session duration
      </p>
      <p className="mt-1 text-lg font-semibold">
        {profile.engagement.avgSessionDuration === null
          ? "—"
          : `${profile.engagement.avgSessionDuration.toFixed(1)}s`}
      </p>
    </div>
  </div>
);
